import React from "react";
import { CircularProgress } from "@mui/material";

export const Loading = (props) => {
  return <CircularProgress data-testid="loading-spinner" {...props} />;
};
